<script lang="ts" setup>
import { useRoute, useRouter } from 'vue-router'

import { useAlert } from '@/libs/alertPortal'
import { captureException } from '@sentry/vue'

import SettingsPagePanel from '../SettingsPagePanel.vue'
import SettingsPageMemberManagementUpdateContentView from './SettingsPageMemberManagementUpdateContentView.vue'
import { useSettingsPageMemberManagementUpdateViewQuery } from './SettingsPageMemberManagementUpdateView.generated'

const route = useRoute('memberManagementSettingEdit')

const router = useRouter()
const alert = useAlert()

const { result, onError } = useSettingsPageMemberManagementUpdateViewQuery(
  {
    staffGUID: route.params.memberManagementSettingId as string,
  },
  {
    fetchPolicy: 'no-cache',
  }
)

onError((error): void => {
  if (
    error.graphQLErrors.some(
      ({ extensions }) => extensions && extensions.code === 'PERMISSION_DENIED'
    )
  ) {
    router.replace({ name: 'errorNotFound' })
    return
  }

  alert.error(
    '読込中にエラーが発生しました。お手数ですが再度読み込みをお願いします。'
  )

  captureException(error)
})

const handleUpdatedStaff = () => {
  // eslint-disable-next-line fp/no-mutating-methods
  router.push({ name: 'memberManagementSetting' })
}
</script>

<template>
  <SettingsPagePanel>
    <SettingsPageMemberManagementUpdateContentView
      v-if="result"
      :staffGUID="route.params.memberManagementSettingId as string"
      :queryFragment="result"
      :staffFragment="result.staff"
      @updatedStaff="handleUpdatedStaff"
    />
  </SettingsPagePanel>
</template>
